var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuritySystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "security_systems") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security_system"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0L0 8V20C0 31.1 7.68 41.48 18 44C28.32 41.48 36 31.1 36 20V8L18 0ZM18 12C20.8 12 23.6 14.2 23.6 17V20C24.8 20 26 21.2 26 22.6V29.6C26 30.8 24.8 32 23.4 32H12.4C11.2 32 10 30.8 10 29.4V22.4C10 21.2 11.2 20 12.4 20V17C12.4 14.2 15.2 12 18 12ZM18 14.4C16.4 14.4 15 15.4 15 17V20H21V17C21 15.4 19.6 14.4 18 14.4Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySystem);
export default __webpack_public_path__ + "static/media/securitySystem.d87dcb63aff2a0a47675e787243959b4.svg";
export { ForwardRef as ReactComponent };